import Container from '@mui/material/Container';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { TimeoffView } from '../../features/schedules/TimeoffView';

const TimeoffPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.TIMEOFF}>
    <Container
      sx={{
        px: {
          xs: 0, lg: 2, md: 2, sm: 2,
        },
      }}
      maxWidth={false}
    >
      <TimeoffView />
    </Container>
  </PageHelmet>
);

export default TimeoffPage;
